import { useContext } from "react";
import { useDispatch } from "react-redux";
import { AuthContext } from "src/context";
import AuthService from "src/function/auth/AuthService";
import { clearBalance } from "src/redux/reducers/balanceReduser";
import { clearOrders } from "src/redux/reducers/ordersReduser";
import { clearData } from "src/redux/reducers/userDataReducer";

const useLogout = () => {
  const { setIsAuth } = useContext(AuthContext);
  const dispatch = useDispatch();

  const logoutUser = async () => {
    await AuthService.fetchLogoutUser();
    localStorage.setItem('auth', 'false')
    setIsAuth(false);

    dispatch(clearBalance());
    dispatch(clearData());
    dispatch(clearOrders());
  }

  return [logoutUser]
}

export default useLogout